import { Chips, IChipsOption } from '@cian/ui-kit';
import { useCallback } from 'react';
import { InlineFilter } from 'shared/components/InlineFilter';

interface ISingleSelectionAdvancedFilterProps<T> {
  value: T[];
  options: IChipsOption<T>[];
  onFilterChange: (newValue: T | null) => void;
}

export function SingleSelectionAdvancedFilter<T>({
  onFilterChange,
  value,
  options,
}: ISingleSelectionAdvancedFilterProps<T>) {
  const handleChange = useCallback(
    (newValue: [T]) => {
      const [nextValue] = newValue;

      onFilterChange(nextValue ?? null);
    },
    [onFilterChange],
  );

  return (
    <InlineFilter>
      <Chips onChange={handleChange} value={value} options={options} selectType="single" size="S" />
    </InlineFilter>
  );
}
